import createHistory from "history/createBrowserHistory";

const appHistory = createHistory();

export default appHistory;